import { Card, CardContent, makeStyles, MenuItem, Select, Typography } from '@material-ui/core'
import React from 'react'
import { Pie } from 'react-chartjs-2'
import PieChartdata from '../../chartsData/PieChartdata'
import CustomHeading from '../CustomHeading'
import HomeSelect from '../HomeSelect'
import Loader from '../Loader'
import { NoDataFound } from '../NoDataFound'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#F5F8FF',
    justifyContent: 'center',
    border: 'none',
    borderRadius: '12px',
    // boxShadow:'none'
  },
  icon: {
    width: '22px',
    height: '22px',
    cursor: 'pointer',
    marginLeft: '22px',
    // marginTop: '4px',
  },
  icons: {
    marginLeft: '20px',
    cursor: 'pointer',
  },
  underline: {
    borderBottom: '1px solid #CCCCCC',
    marginTop: '2px',
  },
  subtitle: {
    fontSize: '28px',
    fontWeight: 'bold',
    letterSpacing: '0.5px',
    lineHeight: ' 38px',
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
  },
  title1: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '19px',
    letter: '0.5px',
    margin: 5,
    color: '#313131',
    // paddingBottom: '30px',
  },
  title4: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '19px',
    margin: 3,
    color: '#313131',
    paddingBottom: '4px',
  },
  title2: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    margin: 5,
    color: '#313131',
  },
  image: {
    // borderRadius: '45%',
    // height: '9%',
    width: '45px',
    height: '45px',
  },
  label: {
    fontSize: '12px',
  },
  srollbar: {
    height: '580px',
    overflowY: 'scroll',
    '&::-webkit-scrollbar': {
      width: '0.3em',
      borderRadius: '2px',
    },
    // '&::-webkit-scrollbar-track': {
    //   boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    //   webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    // },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#CCCCCC',
      // outline: '1px solid slategrey',
    },
  },
}))

export default function LeavePieChart({ leavesRecord, home, loading }) {

  const classes = useStyles()
  const accepted = leavesRecord && leavesRecord.totalApproved
  const rejected = leavesRecord && leavesRecord.totalRejected
  const piedata = {
    labels: ['Rejected Leaves', 'Accepted Leaves'],
    datasets: [
      {
        label: 'My First Dataset',
        data: [rejected, accepted],
        backgroundColor: ['#E786D7', '#779AF4'],
        offset: 100,
        rotation: 90,
      },
    ],
  }
  return (
    // <Card variant="outlined" className={classes.root} style={{ display: 'flex', flexDirection: 'column' }}>
    //   {leavesRecord ? (
    //     <CardContent style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
    //       <Typography className={classes.title1}>Accepted Vs Rejected Leaves</Typography>

    //       <HomeSelect />
    //     </CardContent>
    //   ) : (
    //     <Loader />
    //   )}
    //   {leavesRecord ? (
    //     <div style={{ height: '326px', width: '87%', paddingLeft: '40px' }}>
    <React.Fragment>
      {loading && <div><Loader /></div>}
      {!loading && (accepted > 0 || rejected > 0) && <Pie data={piedata} options={PieChartdata.piechartoptions} height={322} />}
      {!loading && !(accepted > 0) && !(rejected > 0) && <NoDataFound text='No Leaves Found' />}
    </React.Fragment>
    //     </div>
    //   ) : (
    //     <Loader />
    //   )}
    // </Card>
  )
}
